// safeMarkdown — Tiny markdown→sanitized HTML converter used by ED3N reply views.
// Escapes user/LLM text first, applies a very small markdown subset, then runs
// DOMPurify with a strict allow-list so any injected tags/attributes are stripped.
import DOMPurify from "dompurify";

const ALLOWED_TAGS = ["strong", "em", "code", "pre", "br", "p", "ul", "ol", "li", "table", "thead", "tbody", "tr", "th", "td"];
const ALLOWED_ATTR = [];

const escapeHtml = (s) =>
  String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

function mdToHtml(md) {
  let out = escapeHtml(md);
  // Pipe-tables (header row + separator row required)
  const lines = out.split("\n");
  const result = [];
  let i = 0;
  while (i < lines.length) {
    if (lines[i].includes("|") && lines[i + 1] && /^\s*\|?\s*:?-+/.test(lines[i + 1])) {
      const header = lines[i].trim().replace(/^\||\|$/g, "").split("|").map((s) => s.trim());
      i += 2;
      const rows = [];
      while (i < lines.length && lines[i].includes("|")) {
        rows.push(lines[i].trim().replace(/^\||\|$/g, "").split("|").map((s) => s.trim()));
        i++;
      }
      const thead = "<thead><tr>" + header.map((h) => `<th>${h}</th>`).join("") + "</tr></thead>";
      const tbody = "<tbody>" + rows.map((r) => "<tr>" + r.map((c) => `<td>${c}</td>`).join("") + "</tr>").join("") + "</tbody>";
      result.push(`<table>${thead}${tbody}</table>`);
    } else {
      result.push(lines[i]);
      i++;
    }
  }
  out = result.join("\n");
  out = out
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/`([^`]+)`/g, "<code>$1</code>")
    .replace(/\n/g, "<br/>");
  return out;
}

export function renderSafeMarkdown(md) {
  return DOMPurify.sanitize(mdToHtml(md), { ALLOWED_TAGS, ALLOWED_ATTR });
}
